// extracted by mini-css-extract-plugin
export default {"Drawer":"AddInvestmentDrawer_Drawer__g1pCB"};